import React, { Component } from 'react';

export default class NavBar extends Component {
  render() {
    return (
    <div>
      <nav className="navbar fixed-top">
      <a
      className="navbarText"
      >
        Facts about the legendary <span>Chuck Norris</span>
      </a>
      </nav>
    </div>
    );
  } 
}